import React, { Component } from 'react';

import { Badge } from '@schoolinks/ui-components';
import cn from 'classnames';
import { number, func, bool, shape } from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import withUserType from 'containers/withUserType';
import features from 'core/features';

import * as notificationActions from 'modules/Notifications/actions';
import {
  DEFAULT_NOTIFICATION_INTERVAL,
  K12_ADMIN_NOTIFICATION_INTERVAL,
} from 'modules/Notifications/constants';

import s from './UnifiedNotifications.css';

@withUserType
@connect(
  ({ notifications: { unseenCount, unseenMessageCenterCount } }) => ({
    unseenCount,
    unseenMessageCenterCount,
  }),
  dispatch => bindActionCreators({ ...notificationActions }, dispatch),
)
export default class UnifiedNotifications extends Component {
  async componentDidMount() {
    await this.getLatestUnseenCount();
    const { user } = this.props;
    if (!__DEV__ || features.polling) {
      const intervalTime = user?.isCounselor
        ? K12_ADMIN_NOTIFICATION_INTERVAL
        : DEFAULT_NOTIFICATION_INTERVAL;
      this.interval = setInterval(
        () => this.getLatestUnseenCount(),
        intervalTime,
      );
    }
  }

  componentWillUnmount() {
    clearInterval(this.interval);
  }

  getLatestUnseenCount = async () => {
    const { getUnseenNotificationsCount } = this.props;
    try {
      await getUnseenNotificationsCount();
    } catch (e) {
      console.warn('could not fetch latest count', e);
    }
  };

  render() {
    const {
      showMessageDot,
      showNotificationDot,
      unseenCount,
      unseenMessageCenterCount,
      style,
      showCount,
    } = this.props;

    const unseenMsgCenterCount = unseenMessageCenterCount || 0;
    const unseen = unseenCount || 0;

    return showCount ? (
      <Badge
        style={{ ...style }}
        color="red"
        classes={{ root: s.badgeRoot }}
        number={
          showMessageDot * unseenMsgCenterCount + showNotificationDot * unseen
        }
      />
    ) : (
      <div
        style={{ ...style }}
        className={cn(s.root, {
          [s.show]:
            (showMessageDot && unseenMsgCenterCount) ||
            (showNotificationDot && unseen) ||
            (showMessageDot &&
              showNotificationDot &&
              (unseen || unseenMsgCenterCount)),
        })}
      />
    );
  }
}

UnifiedNotifications.propTypes = {
  unseenCount: number.isRequired,
  unseenMessageCenterCount: number,
  getUnseenNotificationsCount: func.isRequired,
  showMessageDot: bool,
  showNotificationDot: bool,
  style: shape({}),
  showCount: bool,
  user: shape({
    isCounselor: bool,
  }).isRequired,
};

UnifiedNotifications.defaultProps = {
  showMessageDot: false,
  showNotificationDot: false,
  style: {},
  showCount: false,
  unseenMessageCenterCount: undefined,
};
